<h2 mat-dialog-title>{{ (isAdd ? 'Add Job Grouping' : 'Edit Job Grouping') | translate }}</h2>

<mat-dialog-content>
  @if (isFormLoading) {
    <div class="loading-wrap">
      <mat-spinner diameter="32"></mat-spinner>
    </div>
  }

  @if (!isFormLoading) {
    <form class="job-dictionary-form" #form="ngForm">
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>{{ 'Code' | translate }}</mat-label>
        <input matInput name="code" required
          [(ngModel)]="entity.code"
          (ngModelChange)="clearCodeError()"
          [class.invalid]="duplicateCodeError" />
        </mat-form-field>
        @if (duplicateCodeError) {
          <div class="field-error">
            {{ "Code '{{code}}' is already in use by an active grouping." | translate: { code: entity.code } }}
          </div>
        }
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>{{ 'Name' | translate }}</mat-label>
          <input matInput name="name" required [(ngModel)]="entity.name" />
        </mat-form-field>
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>{{ 'Description' | translate }}</mat-label>
          <textarea matInput name="description" rows="3" [(ngModel)]="entity.description"></textarea>
        </mat-form-field>
        <div class="toggle-row">
          <span>{{ 'Active' | translate }}</span>
          <mat-slide-toggle name="isActive" [(ngModel)]="entity.isActive"></mat-slide-toggle>
        </div>
      </form>
    }
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-stroked-button type="button" (click)="close()">{{ 'Cancel' | translate }}</button>
    <button mat-flat-button color="primary" type="button"
      [disabled]="isLoading || isFormLoading || !validate()"
      (click)="save()">
      {{ 'Save' | translate }}
    </button>
  </mat-dialog-actions>
